export default __webpack_public_path__ + "static/media/HLR.f74c40f1.ttf";